<template>
  <div class="exchange-i">
    <Header title="毕业设计" type="0" route="/design_msg"></Header>
    
    <div class="list-head">
              <div>
                <p>题目编号：{{itemInit.ktbh}}</p>
                <p>设计（论文）题目：{{itemInit.ktmc}}</p>
              </div>
            </div>
            <NOdata
      v-if="this.designReCodeList && this.designReCodeList.length == 0"
      title="未查询到任何信息"
    ></NOdata>       
    <div class="exchange">
      <div
        class="item"
        v-for="(item, index) of designReCodeList"
        :key="index"
      >
        <ul>
          <li><label>学号：</label>{{ item.xh }}</li>
          <li><label>姓名：</label>{{ item.xm }}</li>
          <li><label>学院：</label>{{ item.dwmc }}</li>
          <li><label>专业：</label>{{ item.zymc }}</li>
          <li><label>班级：</label>{{ item.bj }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      itemInit:{},
      designReCodeList: [],
    };
  },
  methods: {
    async loadMyDesignStudent(){
      const params = {
        sj1102id: this.itemInit.sj1102id,
      };
      const res = await Api.loadMyDesignStudent(params);
      if(res.code=='1'){
        this.designReCodeList = res.data;
      }
    },
  },
  created() {
    this.itemInit = JSON.parse(this.$route.query.itemObj);
    this.loadMyDesignStudent();
  }
};
</script>
<style lang="less" scoped>
.exchange-i {
  .list-head {
      height: 100px;
      background-image: url("../../../../static/image/head.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      padding: 5% 7%;
      box-sizing: border-box;
      margin-bottom: 1%;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      div {
        width: 90%;
        height: 100%;
        p {
          font-size: 14px;
          color: #fff;
          font-weight: lighter;
          margin-bottom: 2%;
        }
        
      
        span {
          
          align-items: center;
          i {
            font-style: normal;
            font-size: 14px;
            color: #fff;
            margin-right: 5%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 80%;
            margin-left: 15px;
          }
          b {
            display: inline-block;
            border-left: 3px solid transparent;
            border-right: 3px solid transparent;
            border-top: 3px solid #fff;
          }
        }
      }
    }
  .exchange {
    padding: 5% 5% 0;
    overflow: auto;
    height: 80vh;
    .item {
      background: #f8f8f8;
      border-radius: 8px;
      margin: 0 auto 5%;
      padding: 3% 3% 3% 6%;
      box-sizing: border-box;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li {
          font-family: PingFangSC-Light;
          font-size: 14px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
          min-height: 16px;
        }

        li label {
          height: 16px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          line-height: 16px;
          margin-bottom: 1%;
          white-space:normal;
          word-break : break-all;
          word-wrap: break-word;
        } 

        li span{
          color:blue;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Design/guideStudentMsg.vue